import { Table } from '../../Table';
import useTable from '../../../hooks/useTable';
import { TableComponentProps } from '../types';

const columnLables = {
  financing_0_to_1_day: {
    name: 'Percentage of financing amount in 0 to 1 day',
    order: 211
  },
  financing_2_to_7_days: {
    name: 'Percentage of financing amount in 2 to 7 days',
    order: 212
  },
  financing_8_to_30_days: {
    name: 'Percentage of financing amount in 8 to 30 days',
    order: 213
  },
  financing_31_to_90_days: {
    name: 'Percentage of financing amount in 31 to 90 days',
    order: 214
  },
  financing_91_to_180_days: {
    name: 'Percentage of financing amount in 91 to 180 days',
    order: 215
  },
  financing_181_to_365_days: {
    name: 'Percentage of financing amount in 181 to 365 days',
    order: 216
  },
  financing_over_365_days: {
    name: 'Percentage of financing amount longer than 365 days',
    order: 217
  }
};

export function FinancingLiquidity2({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.FINANCING_PROFILE,
    onChangeFund,
    schema: schema.FINANCING_PROFILE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.FINANCING_PROFILE?.field_names || [],
    isMultiFunds,
    funds,
    tableName: 'FINANCING_PROFILE',

    columnLables
  });

  return (
    <Table
      id="reporttables-financing-liquidity-2-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
